import React from "react"

export const PageNotFound = () => {
  return (
    <>
      <h1 className="h3">Page Not Found</h1>
    </>
  )
}
